import { render, staticRenderFns } from "./Inscreva.vue?vue&type=template&id=77163fb4&scoped=true&lang=pug&"
import script from "./Inscreva.vue?vue&type=script&lang=js&"
export * from "./Inscreva.vue?vue&type=script&lang=js&"
import style0 from "./Inscreva.styl?vue&type=style&index=0&id=77163fb4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77163fb4",
  null
  
)

export default component.exports